import { Box, Typography } from "@mui/material";
import {
  CHART_CONTAINER_HEIGHT,
  STANDART_CHART_HEIGHT,
} from "../../../system-health/common/values";

import CircularLoading from "../../../../../../common/components/progress/CircularLoading";
import { FeedbackInsightsChartProps } from "../../models";
import SimplePaperWrapper from "../../../../../../common/components/item/SimplePaperWrapper";
import StatisticsNoDataView from "../../../system-performance/components/StatisticsNoDataView";
import StyledChart, {
  apexChartsTooltipStyles,
} from "../../../../../../common/components/apexchart/StyledChart";
import { useFeedbackDetailsChart } from "../../hooks/useFeedbackDetailsChart";

const FeedbackDetailsContainer = ({
  activeTimePeriod,
  selectedLocations,
}: FeedbackInsightsChartProps) => {
  const { series, options, loading, refetching, showNoData } =
    useFeedbackDetailsChart(activeTimePeriod, selectedLocations);

  return (
    <SimplePaperWrapper
      sx={{
        padding: "1.5em",
        width: "100%",
        height: CHART_CONTAINER_HEIGHT,
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Typography variant="h5">Feedback Details</Typography>
      </Box>
      {(loading || refetching) && <CircularLoading />}
      {!loading && !showNoData && (
        <Box sx={apexChartsTooltipStyles}>
          <StyledChart
            options={options}
            series={series}
            height={STANDART_CHART_HEIGHT}
            type="bar"
          />
        </Box>
      )}
      {showNoData && <StatisticsNoDataView />}
    </SimplePaperWrapper>
  );
};

export default FeedbackDetailsContainer;
